import React from 'react';
import { connect } from 'react-redux'
import { makeContractsByKennitala, getDescriptiveContractName, formatKennitala } from '../../utils'
import { getQuestionListToken } from '../../api/questionnaires/actions'
import { Spinner, copyToClipboard } from '../../utils';
import { Link } from 'react-router-dom';
import moment from 'moment';
import { SvgCheckIcon } from '../svg';

class AdditionalQuestionsModal extends React.Component {

	constructor(props) {
		super(props)

		this.state = {
			copied: false,
			multIds: {},
			checkedQ: {}, // List of questionnaires to be sent
			showList: true,
		}

		this.onCheckboxChange = this.onCheckboxChange.bind(this)
		this.clippy = this.clippy.bind(this)
		this.validateButtonDisplay = this.validateButtonDisplay.bind(this)
		this.createQuestionnaireList = this.createQuestionnaireList.bind(this)
	}

	componentDidMount() {
        $(`#${this.props.modalId}`).modal('show')
        $(`#${this.props.modalId}`).on('hidden.bs.modal', () => {
            this.props.modalHidden()
        })
    }

	onCheckboxChange(e, type) {
		const { name, checked } = e.currentTarget;
		var checkedQ = { ...this.state.checkedQ }
		checkedQ[name] = checked;
		this.setState({ checkedQ })
	}

	getCustNameAndKennitala(kennitala) {
		let ktNamePair = Object.entries(this.props.customers.peopleByKennitala).filter(item => item.includes(kennitala))
		let kt = ktNamePair[0][0]
		let name = ktNamePair[0][1]
		return (
			<div className="customer-container">
				<div className="customer">
					<p>{name}</p>
					<span>{formatKennitala(kt)}</span>
				</div>
			</div>)
	}

	// Disable button if object is empty or values are false (checked then unchecked)
	validateButtonDisplay() {
		var emptyOrFalse = true;
		for (const property in this.state.checkedQ) {
			if (this.state.checkedQ[property]) {
				emptyOrFalse = false;
			}
		}
		return emptyOrFalse || this.props.questionnaires.isFetching;
	}

	// Makes a list of questionnaires to be answered by customer - gets token
	createQuestionnaireList(customer) {
		let data = {
			'additionalQuestions': {
				'questionLists': Object.keys(this.state.checkedQ).filter(val => this.state.checkedQ[val] === true),
				'kt': customer.Customer.AccountNum,
				'contractId': this.props.contractId
			},
			'peopleByKennitala': this.props.customers.peopleByKennitala
		}

		this.setState({ showList: !this.state.showList })
		this.props.dispatch(getQuestionListToken(data));
	}

	clippy() {
		let link = document.querySelector('#customer-signing-url');
		link.select()
		document.execCommand('copy');
		window.getSelection().removeAllRanges();
		this.setState({ copied: true })
	}

	render() {
		let { customers } = this.props;


		return (
          <div className="modal additional-questions-modal" tabIndex="-1" role="dialog" aria-labelledby="additionalQuestionsModal"
              aria-hidden="true" id={this.props.modalId}>
              <div className="modal-dialog">
                  <div className="modal-content">
                      <div className="modal-body">
							<>
							{ this.state.showList ? 
								<div className="additional-questions">
									{customers.customerList.map((customer, key) => {
										this.state.multIds[customer.Customer.AccountNum] = []
										return (
											<div key={key} className='tab-content'>
											{Object.entries(makeContractsByKennitala(customer.Contracts)).filter(key => !key.includes("Name")).map(([key, value]) => {
												return (
													<React.Fragment key={key}>
														{this.getCustNameAndKennitala(key)}
														<div className="questionnaire-list">
														{this.props.questionnaires.data.map((questionnaire,key) =>                  
															<div key={key} className="form-row align-items-center checkbox">
																<input type="checkbox" id={`${questionnaire.title}`} name={questionnaire.id} onChange={(e) => this.onCheckboxChange(e, questionnaire)}/>
																<span className="checkmark"></span>
																<label htmlFor={`${questionnaire.title}`} className="col-form-label col-10 col-sm-8">{questionnaire.title}</label>
															</div>
														)}
														</div>
														<div className="col-12 text-center button-container">
															{ this.props.questionnaires.isFetching && 	
																<div className='spinner-container'>
																	<Spinner/>
																</div>
															}
															<button className="btn btn-primary" disabled={this.validateButtonDisplay()} onClick={(e) => this.createQuestionnaireList(customer)}> Stofna spurningalista </button>
														</div>
													</React.Fragment>
												)
											}
											)}
											</div>
										)
									})}
								</div>
								:
								<div className="additional-questions row">
								{ customers.customerList.map((customer, key) => {
									this.state.multIds[customer.Customer.AccountNum] = []
									return (
										<div key={key} className='tab-content'>
										{Object.entries(makeContractsByKennitala(customer.Contracts)).filter(key => !key.includes("Name")).map(([key, value]) => {
											return (
												<React.Fragment key={key}>
													{this.getCustNameAndKennitala(key)}
													<div className="col-12 text-center info-text">
														<p>Spurningalisti hefur verið sendur til útfyllingar inn á mínar síður hjá skjólstæðingi. Smellið að neðan til að fylla út núna.</p>
													</div>
													<div className="row justify-content-center text-center">
														<h4>Útfyllingarslóð fyrir viðskiptavin
															{this.props.createdAt &&
																<>
																	(opin til {moment.utc(this.props.createdAt).add(10, 'days').format("D.M.YYYY")})
																</>
															}</h4>
														<textarea
															id="customer-signing-url"
															readOnly 
															className="linkbox col-12 justify-content-center" 
															value={this.props.customer_signing_url}></textarea>
														<button className="btn btn-primary" onClick={this.clippy} >{this.state.copied && <SvgCheckIcon />} Afrita</button>
													</div>
													<p> </p>
													<div className="col-12 text-center button-container">
														<Link className="btn btn-primary" to={`/fill/${this.props.questionnaires.token}`} onClick={() => $(`#${this.props.modalId}`).modal('hide')}>
															Svara spurningum núna
														</Link>
													</div>
												</React.Fragment>
											)
										}
										)}
										</div>
										)
								})}
							</div>
								}
							</>
                          
                      </div>
                  </div>
              </div>
          </div>
		)
	}
}

function mapStateToProps(state) {

	var f = {
		customers: {},
		offers: {},
		gui: {},
		nationalRegistry: {},
		infoCollection: {},
		brokers: {},
		insuranceTakers: {},
		payers: {},
		employers: {},
		fundTable: {},
		questionnaires: {},
		VIDPartialContract: {},
		createdAt: null,
		customer_signing_url: null
	}
	f.customers = (state.customers === undefined) ? {} : state.customers
	f.offers = (state.offers === undefined) ? {} : state.offers
	f.gui = (state.gui === undefined) ? {} : state.gui
	f.nationalRegistry = (state.nationalRegistry === undefined) ? {} : state.nationalRegistry
	f.infoCollection = (state.infoCollection === undefined) ? {} : state.infoCollection
	f.brokers = (state.brokers === undefined) ? {} : state.brokers
	f.insuranceTakers = (state.insuranceTakers === undefined) ? {} : state.insuranceTakers
	f.payers = (state.payers === undefined) ? {} : state.payers
	f.employers = (state.employers === undefined) ? {} : state.employers
	f.fundTable = (state.fundTable === undefined) ? {} : state.fundTable
	f.questionnaires = (state.questionnaires === undefined) ? {} : state.questionnaires
	f.VIDPartialContract = (state.VIDPartialContract === undefined) ? {} : state.VIDPartialContract
	f.createdAt = (state.questionnaires === undefined) ? null : state.questionnaires.createdAt;
	f.customer_signing_url = (state.questionnaires === undefined) ? null : state.questionnaires.customer_signing_url;


	return f;
}

export default connect(mapStateToProps)(AdditionalQuestionsModal);